const actionLightboxes = document.querySelectorAll('[data-lightbox]');

const initialiseLightbox = (dataset) => {
  let lightbox = document.createElement('dialog');
  lightbox.classList.add('lightbox');

  lightbox.innerHTML = `
    <div class="lightbox__overlay"></div>
    <div class="lightbox__container">
      <div class="lightbox__wrapper" data-width="wide">
        <div class="lightbox__content"></div>
      </div>
    </div>
    <a href="#" class="lightbox__close">
      <span class="lightbox__bar"></span>
      <span class="lightbox__bar"></span>
    </a>
  `;

  // Append the lightbox to the document body
  document.body.appendChild(lightbox);

  let lightboxContent = lightbox.querySelector('.lightbox__content');

  if (dataset.image) {
    lightboxContent.innerHTML = `
    <figure class="lightbox__image">
      <img src="${dataset.image}" alt="${dataset.caption}">
    </figure>`;
  } else if (dataset.video) {
    lightboxContent.innerHTML = `
      <div class="lightbox__video">
        <video controls autoplay preload="auto" playsinline>
          <source src="${dataset.video}" type="video/mp4">
          ${localizedData.video_support}
        </video>
      </div>`;
  }

  // Close lightbox on clicking outside the content
  lightbox.addEventListener('click', e => {
    const isOutsideContent = !e.target.closest('.lightbox__content');
    const close = e.target.closest('.lightbox__close');
    
    if (isOutsideContent || close) {
      e.preventDefault();
      lightbox.classList.remove('is-visible');
      setTimeout(() => {
        lightbox.remove();
      }, 200);
    }
  });

  // Open the lightbox
  lightbox.showModal();

  setTimeout(() => {
    lightbox.classList.add('is-visible');
  });
}

actionLightboxes.forEach(actionLightbox => {
  actionLightbox.addEventListener('click', e => {
    e.preventDefault();
    initialiseLightbox(actionLightbox.dataset);
  });
});
